import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Mail, FlaskConical } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import api from "@/lib/api";

export default function OpsRequests() {
  const navigate = useNavigate();
  const [demos, setDemos] = useState([]);
  const [busy, setBusy] = useState(false);

  const load = async () => { const { data } = await api.get("/ops/demo-requests"); setDemos(data); };
  useEffect(() => { load(); }, []);

  const setDemoStatus = async (rid, status) => { await api.put(`/ops/demo-requests/${rid}`, { status }); toast.success(`Marked ${status.replace("_", " ")}`); load(); };
  const createDemoFrom = async (rid) => {
    setBusy(true);
    try { const { data } = await api.post("/ops/orgs/demo", { request_id: rid }); toast.success(`Demo org created — ${data.contacts} sandbox contacts, live send off`); await load(); navigate("/ops/demos"); }
    catch { toast.error("Could not create demo org"); } finally { setBusy(false); }
  };

  return (
    <div className="max-w-3xl space-y-2" data-testid="ops-demo-list">
      {demos.length === 0 ? <p className="text-sm text-muted-foreground p-3">No demo requests yet.</p> : demos.map((d) => (
        <div key={d.id} className="rounded-lg border border-border/60 p-3" data-testid={`ops-demo-${d.id}`}>
          <div className="flex items-center justify-between gap-2">
            <span className="flex items-center gap-2 min-w-0"><Mail className="h-4 w-4 text-muted-foreground shrink-0" /><span className="font-medium truncate">{d.company}</span></span>
            <Badge variant="outline" className="text-[10px] capitalize shrink-0">{(d.status || "new").replace("_", " ")}</Badge>
          </div>
          <div className="text-xs text-muted-foreground mt-1 truncate">{d.work_email} · {new Date(d.created_at).toLocaleDateString()}</div>
          {d.what_they_sell && <div className="text-[11px] text-muted-foreground mt-0.5 truncate">Sells: {d.what_they_sell}{d.team_size ? ` · ${d.team_size}` : ""}</div>}
          <div className="flex flex-wrap gap-1.5 mt-2">
            <Button size="sm" variant="outline" className="h-7 text-xs" onClick={() => setDemoStatus(d.id, "scheduled")} data-testid={`demo-schedule-${d.id}`}>Scheduled</Button>
            <Button size="sm" variant="outline" className="h-7 text-xs" onClick={() => setDemoStatus(d.id, "declined")} data-testid={`demo-decline-${d.id}`}>Decline</Button>
            <Button size="sm" className="h-7 text-xs rounded-md bg-amber-500 text-black hover:bg-amber-400" onClick={() => createDemoFrom(d.id)} disabled={busy} data-testid={`demo-create-org-${d.id}`}><FlaskConical className="h-3 w-3 mr-1" /> Create demo org</Button>
          </div>
        </div>
      ))}
    </div>
  );
}
